@if(introductionData){
  <div class="sx-help-introduction">
    @if(introductionData?.description){
      <div class="sx-help-introduction__description" [innerHTML]="introductionData.description | safeHtml" appRouterLink></div>
    }
    
    @for(guide of guides; track guide; let i = $index){
      <div class="sx-help-introduction__link">
        <a href="javascript:void(0)" (click)="openGuide(guide)" id="intro_link_{{i}}">{{ guide.name }}</a>
        <span>{{ guide.changed | date:'shortDate'}}</span>
      </div>
    }
  </div>
}

